var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgZLogoPressed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M216.292 457.584L431.584 242.292L216.292 27L1 242.292L216.292 457.584Z",
    fill: "#440861",
    stroke: "#7C349E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M231.946 128.098C223.005 128.247 211.433 132.561 198.621 145.373L108.145 235.849L93.2954 221L183.772 130.524C199.358 114.937 215.853 107.364 231.595 107.101C247.387 106.837 260.938 113.977 270.194 124.878C288.612 146.57 290.3 183.133 263.341 210.092L255.916 202.668L248.492 195.243C267.761 175.974 265.487 151.78 254.186 138.47C248.583 131.871 240.836 127.949 231.946 128.098ZM255.916 202.668C248.492 195.243 248.492 195.243 248.492 195.243L248.49 195.244L248.487 195.248L170.564 273.171C155.942 287.793 148.699 303.486 148.198 318.529C147.696 333.604 154.034 346.812 164.209 355.938C184.698 374.315 219.426 375.522 246.17 348.777L337.5 257.448L330.076 250.022L322.651 242.598L231.321 333.928C211.837 353.412 189.77 350.656 178.23 340.305C172.39 335.067 168.904 327.721 169.186 319.228C169.47 310.703 173.619 299.814 185.413 288.02L263.34 210.094L263.341 210.092C263.341 210.092 263.341 210.092 255.916 202.668Z",
    fill: "#7C349E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M85.5318 271.283C100.814 271.283 113.202 258.895 113.202 243.613C113.202 228.331 100.814 215.942 85.5318 215.942C70.2498 215.942 57.8613 228.331 57.8613 243.613C57.8613 258.895 70.2498 271.283 85.5318 271.283Z",
    stroke: "#7C349E",
    fill: "#440861",
    strokeWidth: 21
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M347.052 260.717C362.334 260.717 374.723 248.328 374.723 233.046C374.723 217.764 362.334 205.376 347.052 205.376C331.77 205.376 319.382 217.764 319.382 233.046C319.382 248.328 331.77 260.717 347.052 260.717Z",
    stroke: "#7C349E",
    fill: "#440861",
    strokeWidth: 21
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgZLogoPressed);
export default __webpack_public_path__ + "static/media/z-logo-pressed.c048ea77164940fb319e1f8d2d4ab2fc.svg";
export { ForwardRef as ReactComponent };